// import { SaleListUrlSortField } from "@saleor/discounts/urls";
import { RegisterListUrlSortField } from "@saleor/register/urls";
import { RecommendSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: RegisterListUrlSortField
): RecommendSortField {
  switch (sort) {
    case RegisterListUrlSortField.fromEmail:
      return RecommendSortField.FROM_EMAIL;
    case RegisterListUrlSortField.recommendEmail:
      return RecommendSortField.RECOMMEND_EMAIL;
    case RegisterListUrlSortField.created:
      return RecommendSortField.CREATED;
    // case RegisterListUrlSortField.name:
    //   return RecommendSortField.NAME;
    // case RegisterListUrlSortField.value:
    //   return SaleSortField.VALUE;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
